// extracted by mini-css-extract-plugin
export default {"crossIcon":"fLSoTbh6ffbs78IaQxxr","addButton":"tL6kafAF_rqZIhOtmluW"};